// Cart lines save their quantity once the stepper settles, so a run of + clicks
// sends one request. update.js.erb reloads the page with the new totals.
var SAVE_DELAY_MS = 600

$(document).on("change", ".js-cart-item-qty", function () {
  var input = this
  var $form = $(input.form)

  clearTimeout($form.data("saveTimer"))
  $form.data(
    "saveTimer",
    setTimeout(function () {
      if (input.value === input.defaultValue || !input.checkValidity()) return
      $form.addClass("is-saving")
      $form.trigger("submit")
    }, SAVE_DELAY_MS)
  )
})

// A rejected quantity puts the saved value back rather than failing silently.
$(document).on("ajax:error", ".js-cart-item-qty-form", function () {
  var input = $(this).find(".js-cart-item-qty")[0]
  input.value = input.defaultValue
  $(input).trigger("change")
  $(this).removeClass("is-saving")
})
